
import 'normalize.css';
import 'flatpickr/dist/flatpickr.css';
import '../scss/main.scss';
import '../scss/style.scss';
import '../scss/editor-style.scss';
import '../scss/admin-forms.scss';

import '../images/logo.svg';
import '../images/logo.png';
import '../images/icon-check.svg';
import '../images/energy-label-space-a.svg';
import '../images/energy-label-water-a-l.svg';
import '../images/energy-label-water-a-xl.svg';
import '../images/energy-label-water-a-xxl.svg';
import '../images/thermostat-404.png';

// search installer assets
import '../images/marker-installer.png';
import '../images/marker-current.png';
import '../images/icon-stockist-intergas.svg';
import '../images/icon-stockist-rapid.svg';
import '../images/icon-stockist-spare-parts.svg';

// widget assets
import '../images/icon-award-ribbon.svg';
import '../images/icon-co2.svg';
import '../images/icon-document.svg';
import '../images/icon-exclamation-mark.svg';
import '../images/icon-graduation-cap.svg';
import '../images/icon-installer.svg';
import '../images/icon-installer-ribbon.svg';
import '../images/icon-labels.svg';
import '../images/icon-leaves.svg';
import '../images/icon-light-bulb.svg';
import '../images/icon-magnifying-glass.svg';
import '../images/icon-phone.svg';
import '../images/icon-plus.svg';
import '../images/icon-question-mark.svg';
import '../images/icon-sheet.svg';
import '../images/icon-speaker-horn.svg';
import '../images/icon-speech-bubble.svg';

// backend assets
import '../screenshot.png';
import '../images/logo-square.svg';

// product icons
import '../images/product-icon-10-years-warranty.svg';
import '../images/product-icon-12-years-warranty.svg';
import '../images/product-icon-15-years-warranty.svg';
import '../images/product-icon-2-years-warranty.svg';
import '../images/product-icon-3-years-warranty.svg';
import '../images/product-icon-3-years-warranty-on-parts-and-labour.svg';
import '../images/product-icon-5-years-warranty.svg';
import '../images/product-icon-6-years-warranty-on-heat-exchanger.svg';
import '../images/product-icon-6-years-warranty.svg';
import '../images/product-icon-7-years-warranty-on-heat-exchanger.svg';
import '../images/product-icon-7-years-warranty.svg';
import '../images/product-icon-energy-saving-trust.svg';

// email assets
import '../email/email-header.jpg';
import '../email/email-header-xtreme.jpg';
import '../email/email-header-hre.jpg';

// templates
import ViewInstallerListNl from './templates/installer-list-nl.mustache';
import ViewInstallerListGb from './templates/installer-list-gb.mustache';
import ViewMerchantListNl from './templates/merchant-list-nl.mustache';
import ViewMerchantListGb from './templates/merchant-list-gb.mustache';

import HeaderStatus from './headerstatus.js';
import SideNav from './menu.js';
import LightBox from './lib/lightbox.js';
import CarouselSlider from './lib/carousel.js';
import Form from './form.js';
import FormField from './form-field.js';
import ProductsFilter from './product-filter.js';
import Documents from './documents.js';
import Tabs from './lib/tabs.js';
import Faq from './lib/faq.js';
import SearchDistributors from './search-distributor.js';
import Distributor from './distributor.js';
import Hooks from './hooks.js';
import CookiePolicy from './cookie-policy.js';
import flatpickr from 'flatpickr';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import { German } from 'flatpickr/dist/l10n/de.js';

// modules
import ModuleMap from './modules/module-map.js';
import '../images/marker-intergas.png';

// make global To do: better to resolve this without making global.
window.LightBox = LightBox;
window.CarouselSlider = CarouselSlider;
window.Form = Form;
window.FormField = FormField;
window.ProductsFilter = ProductsFilter;
window.Documents = Documents;
window.Tabs = Tabs;
window.Faq = Faq;
window.SearchDistributor = SearchDistributors;
window.Distributor = Distributor;

// TODO: yikes
Distributor.prototype.renderInstallerListNl = ViewInstallerListNl;
Distributor.prototype.renderInstallerListGb = ViewInstallerListGb;
Distributor.prototype.renderMerchantListNl = ViewMerchantListNl;
Distributor.prototype.renderMerchantListGb = ViewMerchantListGb;

window.Hooks = Hooks;
window.flatpickrDuch = Dutch;
window.flatpickrGerman = German;
if(ig_current_locale == 'en_GB'){
	flatpickr.l10ns.default.firstDayOfWeek = 1;
}


window.addEventListener('DOMContentLoaded', function(){
	const sideNav = new SideNav(document.getElementById('header-navigation-wrapper'), document.getElementById('header-navigation-container'), document.getElementById('header-menu-button'));
}, false);

window.addEventListener('DOMContentLoaded', function(){
	const headerStatus = new HeaderStatus(
		document.body,
		[
			{
				'scrolled': 90,
				'class': 'scrolled-down'
			}
		]
	);
});

window.addEventListener('DOMContentLoaded', function(){
	if(typeof cookieLocalization != 'undefined' && cookieLocalization.message){
		const cookiePolicy = new CookiePolicy();
		const cookie = cookiePolicy.readCookie('cookie-popup-shown');

		if(!cookie){
			cookiePolicy.showCookieMessage(cookieLocalization.message, cookieLocalization.infoPageUrl, cookieLocalization.closeButtonText);
			cookiePolicy.createCookie('cookie-popup-shown', '1', 60);
		}
	}
});

window.addEventListener('DOMContentLoaded', function() {
	const languageMenuButton = document.querySelector('.header-menu-language-current-button');

	if(!languageMenuButton) {
		return;
	}

	const languageMenuWrapper = document.querySelector('.header-language-menu-wrapper');
	const languageMenuContainer = document.querySelector('.header-language-menu-container');

	languageMenuButton.addEventListener('click', function() {
		languageMenuWrapper.classList.toggle('is-active');
	});

	if(languageMenuWrapper.classList.contains('header-language-menu-type-modal')) {
		languageMenuWrapper.addEventListener('click', function(event) {
			if(event.target === languageMenuWrapper) {
				this.classList.remove('is-active');
			}
		});
	}
	else {
		window.addEventListener('click', function(event) {
			if(!languageMenuWrapper.contains(event.target) && event.target !== languageMenuButton) {
				languageMenuWrapper.classList.remove('is-active');
			}
		});
	}
});

window.addEventListener('DOMContentLoaded', function(){
	if(!ajax_url_get_intergas_company_info){
		return;
	}

	let mapElements = document.getElementsByClassName('map-wrapper');

	mapElements = [].slice.call(mapElements);

	if(mapElements.length < 1){
		return;
	}

	mapElements.forEach(mapElement => {
		new ModuleMap(
			mapElement,
			{
				'ajaxUrlLocation' : ajax_url_get_intergas_company_info,
			},
			translation_module_map_strings
		);
	});
});
